<template>
  <div class="input-form-wrap-row spacing-height">
    <div class="input-label">
      <span style="color: red" v-if="required">*</span>
      <span>{{ label }}</span>
    </div>
    <el-radio-group class="input-form" v-model="selectedValue">
      <el-radio label="0" :disabled="isEditServOrder=='1'">{{oneText}}</el-radio>
      <el-radio label="1" :disabled="isEditServOrder=='1'">{{twoText}}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'RadioField',
  props: {
    label: String,
    value: [String, Number],
    isDisabled: Boolean,
    required: Boolean,
    oneText: {
      type: String,
      default:'否'
    },
    twoText: {
      type: String,
      default:'是'
    },
    isEditServOrder:{
      type:String
    }
  },
  data() {
    return {
      selectedValue: this.value === undefined || (typeof this.value !== 'number' && !this.value) ? 0 : this.value
    };
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    selectedValue(newValue) {
      this.$emit('input', newValue);
    }
  }
};
</script>
<style scoped>
  .input-form {
    width: 186px;
    height: 40px;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// RadioField.vue?868b6838